export default __webpack_public_path__ + "static/404-eca0eaf14327544a24d543816f4976a1.png";